import vars from '../globals';

$(window).on('resize scroll', (e) => {
	if (!vars.isMobile()) {
		return;
	}

	let $currentItem = $(e.currentTarget);

	let firstHeight = $('.product-hero').outerHeight();

	if ($currentItem.scrollTop() >= firstHeight && firstHeight !== 0) {
		$('.product-progress').addClass('isActive');
	} else {
		$('.product-progress').removeClass('isActive');
	}

	let totalHeight = $(document).height();

	let progress = $(window).scrollTop();

	let percentage = progress / (totalHeight - $(window).height()) * 100;

	$('.product-progress__face').css('width', `${percentage}%`);
});
